// src/GLOBAL/geo.ts

export const COUNTRY_TO_CONTINENT: Record<string, string> = {
  estonia: "Europe", latvia: "Europe", lithuania: "Europe", finland: "Europe",
  sweden: "Europe", norway: "Europe", denmark: "Europe", germany: "Europe",
  france: "Europe", spain: "Europe", italy: "Europe", portugal: "Europe",
  poland: "Europe", "united kingdom": "Europe", ireland: "Europe",
  netherlands: "Europe", belgium: "Europe", austria: "Europe",
  switzerland: "Europe", greece: "Europe", "czech republic": "Europe",
  hungary: "Europe", romania: "Europe", croatia: "Europe", iceland: "Europe",

  "united states": "North America", canada: "North America", mexico: "North America",

  brazil: "South America", argentina: "South America", chile: "South America",
  peru: "South America", colombia: "South America",

  nigeria: "Africa", kenya: "Africa", "south africa": "Africa", egypt: "Africa",
  morocco: "Africa", ghana: "Africa", tanzania: "Africa", ethiopia: "Africa",

  china: "Asia", japan: "Asia", india: "Asia", thailand: "Asia",
  "united arab emirates": "Asia", "south korea": "Asia", indonesia: "Asia",
  vietnam: "Asia", "saudi arabia": "Asia", israel: "Asia", turkey: "Asia",

  australia: "Oceania", "new zealand": "Oceania", fiji: "Oceania",
};

export const getContinent = (country?: string | null): string | null => {
  if (!country) return null;
  return COUNTRY_TO_CONTINENT[country.toLowerCase().trim()] ?? null;
};